import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { COLORS, ELEVATIONS, SIZES } from '../styleVars';
import { Typography } from '../typography/Typography';
var Container = styled.div.withConfig({
  componentId: "sc-vdy88x-0"
})(["display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;"]);
var Switch = styled.div.withConfig({
  componentId: "sc-vdy88x-1"
})(["display:inline-block;position:relative;outline:none;user-select:none;margin-left:", ";"], SIZES['8']);
var Track = styled.div.withConfig({
  componentId: "sc-vdy88x-2"
})(["background-color:", ";width:", ";height:", ";border-radius:", ";border:none;"], function (props) {
  return props.checked ? COLORS.fupaSecondary : COLORS.lightGrey;
}, SIZES['42'], SIZES['16'], SIZES['12']);
var ThumbUnderlay = styled.div.withConfig({
  componentId: "sc-vdy88x-3"
})(["left:", ";right:auto;display:flex;position:absolute;top:-", ";align-items:center;justify-content:center;width:", ";height:", ";"], function (props) {
  return props.checked ? SIZES['10'] : "-".concat(SIZES['16']);
}, SIZES['16'], SIZES['48'], SIZES['48']);
var Thumb = styled.div.withConfig({
  componentId: "sc-vdy88x-4"
})(["box-shadow:", ";box-sizing:border-box;width:", ";height:", ";border-radius:50%;pointer-events:none;border:", " solid ", ";z-index:1;input{-webkit-tap-highlight-color:transparent;left:0;right:auto;position:absolute;top:0;height:", ";margin:0;opacity:0;cursor:pointer;pointer-events:auto;}"], ELEVATIONS.Button, SIZES['20'], SIZES['20'], SIZES['10'], COLORS.white, SIZES['48']);

var SwitchButton = function SwitchButton(_ref) {
  var _ref$initiallyChecked = _ref.initiallyChecked,
      initiallyChecked = _ref$initiallyChecked === void 0 ? false : _ref$initiallyChecked,
      label = _ref.label,
      onToggle = _ref.onToggle,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _useState = useState(initiallyChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  useEffect(function () {
    onToggle(checked);
  }, [checked]);

  var handleClick = function handleClick() {
    setChecked(!checked);
  };

  return /*#__PURE__*/React.createElement(Container, {
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1",
    component: "label",
    htmlFor: label
  }, label), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Track, {
    checked: checked
  }), /*#__PURE__*/React.createElement(ThumbUnderlay, {
    checked: checked
  }, /*#__PURE__*/React.createElement(Thumb, null, /*#__PURE__*/React.createElement("input", {
    tabIndex: tabIndex,
    id: label,
    type: "checkbox",
    role: "switch"
  })))));
};

export { SwitchButton };
//# sourceMappingURL=SwitchButton.js.map